import EventsAdapter from './base';

export default class Permission extends EventsAdapter {
  modelNamePlural = 'permissions';
}
